import { render, staticRenderFns } from "./AddNewPolicy.vue?vue&type=template&id=4f8642ee&"
import script from "./AddNewPolicy.vue?vue&type=script&lang=js&"
export * from "./AddNewPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports